import { injectable, inject } from 'inversify';
import {
  DataroomFormDataUploadAdapter, UploadDispatcher, DataroomFormDataUploadStrategy,
} from '@dealroadshow/file-uploader';
import dataroomUrlFactory from '@/dataroom/infrastructure/dataroomUrl';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { type IDataroomTenantContext, DataroomTenantContextSymbol } from '@dataroom/tenant/types';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import Container from '@framework/di/Container';

@injectable()
class FormDataFileUploadDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
  ) {}

  create = (tenantCode: DataroomTenant | null = null) => {
    const tenant = tenantCode || this.container.get<IDataroomTenantContext>(DataroomTenantContextSymbol).tenant;

    validateDataroomTenant(tenant);

    const dataroomUrl = dataroomUrlFactory(tenant);

    const formDataUploadAdapter = new DataroomFormDataUploadAdapter({
      url: dataroomUrl.getFormDataUploadFileUrl(),
    });

    return new UploadDispatcher(
      new DataroomFormDataUploadStrategy(formDataUploadAdapter),
    );
  };
}

export default FormDataFileUploadDispatcherFactory;
